<div class="user-admins-page page-shell">
  <mat-toolbar class="header">
    <span>{{ "userAdmins.header" | translate }}</span>
    <div class="header-buttons">
      <button
        mat-raised-button
        color="primary"
        type="button"
        (click)="addAdmin()"
      >
        <mat-icon>add</mat-icon>
        {{ "userAdmins.new" | translate }}
      </button>
    </div>
  </mat-toolbar>

  <div class="user-admins-content">
    <div
      class="table-container"
      [class.table-container--empty]="!isLoading && dataSource.data.length === 0"
      [class.table-container--loading]="isLoading"
    >
      <table mat-table [dataSource]="dataSource" class="mat-elevation-z0">
        <ng-container matColumnDef="email">
          <th mat-header-cell *matHeaderCellDef>
            {{ "userAdmins.email" | translate }}
          </th>
          <td mat-cell *matCellDef="let element">{{ element.email }}</td>
        </ng-container>

        <ng-container matColumnDef="role">
          <th mat-header-cell *matHeaderCellDef>
            {{ "userAdmins.role" | translate }}
          </th>
          <td mat-cell *matCellDef="let element">
            <code>{{ element.role }}</code>
          </td>
        </ng-container>

        <ng-container matColumnDef="createdAt">
          <th mat-header-cell *matHeaderCellDef>
            {{ "userAdmins.createdAt" | translate }}
          </th>
          <td mat-cell *matCellDef="let element">
            <span [matTooltip]="element.createdAt">
              {{ element.createdAt | localizedDate }}
            </span>
          </td>
        </ng-container>

        <ng-container matColumnDef="activityTime">
          <th mat-header-cell *matHeaderCellDef>
            {{ "userAdmins.activityTime" | translate }}
          </th>
          <td mat-cell *matCellDef="let element">
            {{ element.activityTime | formatDuration }}
          </td>
        </ng-container>

        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let element">
            <div class="table-actions">
              <button
                type="button"
                class="action-btn"
                *ngIf="canManageAdmin(element)"
                (click)="editAdmin(element); $event.stopPropagation()"
              >
                <mat-icon>edit</mat-icon>
                {{ "edit" | translate }}
              </button>
              <button
                type="button"
                class="action-btn action-btn--danger"
                *ngIf="canManageAdmin(element)"
                (click)="removeAdmin(element.userRoleId); $event.stopPropagation()"
              >
                <mat-icon>delete_outline</mat-icon>
                {{ "delete" | translate }}
              </button>
            </div>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr
          mat-row
          *matRowDef="let row; columns: displayedColumns"
          [class.table-row--clickable]="canManageAdmin(row)"
          (click)="onRowClick(row)"
        ></tr>
      </table>

      <div class="loading-wrapper" *ngIf="isLoading">
        <app-loading></app-loading>
      </div>

      <div class="empty-state" *ngIf="!isLoading && dataSource.data.length === 0">
        <mat-icon class="empty-state__icon">admin_panel_settings</mat-icon>
        <p>{{ "userAdmins.noAdmins" | translate }}</p>
      </div>
    </div>
  </div>
</div>
